import { render, staticRenderFns } from "./SvehiclesalesorderUpdate.vue?vue&type=template&id=509f879b&scoped=true"
import script from "./SvehiclesalesorderUpdate.vue?vue&type=script&lang=js"
export * from "./SvehiclesalesorderUpdate.vue?vue&type=script&lang=js"
import style0 from "./SvehiclesalesorderUpdate.vue?vue&type=style&index=0&id=509f879b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509f879b",
  null
  
)

export default component.exports